import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';
import MuiCheckbox from '@mui/material/Checkbox';
import MuiFormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '../styles';
import useFieldId from '../useFieldId';
const StyledMuiFormControlLabel = styled(MuiFormControlLabel)(({
  theme
}) => ({
  alignItems: 'flex-start',
  '& .MuiFormControlLabel-label.Mui-disabled': {
    color: theme.palette.form.selection.text.disabled
  }
}));
const StyledMuiCheckbox = styled(MuiCheckbox, {
  shouldForwardProp: prop => prop !== 'error'
})<{
  error?: boolean;
}>(({
  theme: {
    palette
  },
  error
}) => ({
  marginTop: -9,
  color: error ? palette.form.selection.icon.error : palette.form.selection.icon.enabled,
  ...(error && {
    '&.Mui-checked': {
      color: palette.form.selection.icon.error
    }
  }),
  '&.Mui-disabled': {
    color: palette.form.selection.icon.disabled
  }
}));
export interface Props extends MuiCheckboxProps {
  label: ReactNode;
  name: string;
  hasError?: boolean;
}
const Checkbox = t0 => {
  const $ = _c(22);
  let hasError;
  let id;
  let label;
  let name;
  let otherProps;
  let ref;
  let t1;
  if ($[0] !== t0) {
    ({
      sx: t1,
      label,
      name,
      hasError,
      id,
      ref,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = hasError;
    $[2] = id;
    $[3] = label;
    $[4] = name;
    $[5] = otherProps;
    $[6] = ref;
    $[7] = t1;
  } else {
    hasError = $[1];
    id = $[2];
    label = $[3];
    name = $[4];
    otherProps = $[5];
    ref = $[6];
    t1 = $[7];
  }
  let t2;
  if ($[8] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const sx = t2;
  const {
    fieldId
  } = useFieldId(name, id);
  let t3;
  if ($[10] !== sx) {
    t3 = {
      width: 1,
      ...sx
    };
    $[10] = sx;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== fieldId || $[13] !== hasError || $[14] !== name || $[15] !== otherProps || $[16] !== ref) {
    t4 = <StyledMuiCheckbox id={fieldId} name={name} ref={ref} error={hasError} {...otherProps} />;
    $[12] = fieldId;
    $[13] = hasError;
    $[14] = name;
    $[15] = otherProps;
    $[16] = ref;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== label || $[19] !== t3 || $[20] !== t4) {
    t5 = <StyledMuiFormControlLabel sx={t3} label={label} control={t4} />;
    $[18] = label;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
};
export default Checkbox;